import { ProviderType } from "../enums/provider-type.enum";
import { TargetPeopleArrayInterface, TargetPeopleInterface } from "../interfaces/target-people.interface";

export class TargetPeople implements TargetPeopleInterface {
  _id?: string;
  contact?: string;
  provider?: ProviderType;

  constructor(data: TargetPeopleInterface) {
    this._id = data._id || '';
    this.contact = data.contact || '';
    this.provider = data.provider;
  }

  static fromJson(data: TargetPeopleInterface): TargetPeople {
    return new TargetPeople(data);
  }
  static fromJsonArray(data: TargetPeopleArrayInterface): TargetPeopleArray {
    return data.map((item) => new TargetPeople(item));
  }

  get formattedContact(): string {
    return this.contact || 'Contacto sin información';
  }
  get formattedProvider(): string {
    return this.provider || 'Proveedor sin información';
  }
}

export type TargetPeopleArray = TargetPeople[];
